import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { SurveyQuery } from '../../queries/survey_query';
import { SurveyQuestionQuery } from '../../queries/survey_question_query';
import {
  ISurveyQuestionDirection,
  SurveyQuestionDirectionStrategy
} from '../../strategies/survey_question_direction_strategy';
import { SurveyQuestionTypeStrategy } from '../../strategies/survey_question_type_strategy';

export class SurveyQuestionContentController {
  private flags: {
    isLoading: boolean;
    isSubmitting: boolean;
    hasFormError: boolean;
  };
  private gotoPriorQuestionBound: () => void;

  constructor(
    private ngSurveyQuestionQuery: SurveyQuestionQuery,
    private ngSurveyQuery: SurveyQuery,
    private loadSurveyQuestionCommand: ICommand,
    private saveSurveyQuestionResponseCommand: ICommand,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngComponentCommunicatorService: CommunicatorService
  ) {
    this.flags = {
      isLoading: false,
      isSubmitting: false,
      hasFormError: false
    };
  }

  $onInit() {
    this.gotoPriorQuestionBound = this.gotoPriorQuestion.bind(this);
    this.loadQuestion(SurveyQuestionDirectionStrategy.getByKey('RESUME'));
    this.ngComponentCommunicatorService.subscribe('SURVEY_QUESTION_GOTO_PRIOR', this.gotoPriorQuestionBound);
  }

  get survey() {
    return _4.find(this.ngSurveyQuery.result, (survey) => survey.id === this.$stateParams.surveyID);
  }

  submitQuestionResponse(event: JQueryEventObject & { details: { value: Record<string, string> } }) {
    if (this.flags.isLoading || this.flags.isSubmitting) {
      return;
    }

    const question = this.ngSurveyQuestionQuery.result.question.question;
    const formResponse = _4.get(event, `originalEvent.detail.value[question-${question.id}]`, []);

    this.flags.hasFormError = false;
    const response = SurveyQuestionTypeStrategy.getByKey(question.question_type).buildResponse(formResponse);

    const surveyID = _4.get(this, 'survey.id');
    this.publishSubmitting(true);
    this.saveSurveyQuestionResponseCommand(surveyID, question.id, response)
      .then(() => {
        this.loadQuestion(SurveyQuestionDirectionStrategy.getByKey('NEXT'));
        this.publishSubmitting(false);
      })
      .catch(() => {
        this.publishSubmitting(false);
      });
  }

  showFormError(event: JQueryEventObject & { details: { value: Record<string, string> } }) {
    if (this.flags.isLoading || this.flags.isSubmitting) {
      return;
    }
    const question = this.ngSurveyQuestionQuery.result.question.question;
    const formResponse = _4.get(event, `originalEvent.detail.value[question-${question.id}]`, []);
    const isRequiredQuestion = question.response_required;
    if (!_4.isNumber(formResponse) && _4.isEmpty(formResponse) && isRequiredQuestion) {
      this.flags.hasFormError = true;
    }
  }

  publishSubmitting(isSubmitting: boolean) {
    this.flags.isSubmitting = isSubmitting;
    if (isSubmitting) {
      this.ngComponentCommunicatorService.publish('SURVEY_QUESTION_IS_SUBMITTING');
    } else {
      this.ngComponentCommunicatorService.publish('SURVEY_QUESTION_NOT_SUBMITTING');
    }
  }

  loadPreviousQuestion() {
    this.loadQuestion(SurveyQuestionDirectionStrategy.getByKey('PRIOR'));
  }

  loadQuestion(direction: ISurveyQuestionDirection) {
    if (this.flags.isLoading) {
      return;
    }

    const surveyID = _4.get(this, 'survey.id');

    this.flags.isLoading = true;
    this.loadSurveyQuestionCommand(surveyID, direction.queryName)
      .then(() => {
        this.flags.isLoading = false;
        this.clearFormValidation();
        this.manageStateTransition(direction);
      })
      .catch(() => {
        this.flags.isLoading = false;
      });
  }

  gotoPriorQuestion() {
    this.clearFormValidation();
  }

  clearFormValidation() {
    this.flags.hasFormError = false;
  }

  manageStateTransition(direction: ISurveyQuestionDirection) {
    const question = this.ngSurveyQuestionQuery.result.question;
    const surveyID = _4.get(this, 'survey.id');

    if (_4.isEmpty(question)) {
      this.$state.go(direction.newState, { surveyID });
    }
  }
}

export class SurveyQuestionContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-survey/src/components/survey_question_content/survey_question_content.html';
  public controller: object = SurveyQuestionContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/components/survey_question_content/survey_question_content.ts